import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, Typography, TextField, FormControl } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
// import Activities from '../../components/Dialog/ActivitiesView';
import SummaryReportPage from '../summaryReport/SummaryReportPage';
import { clearLocalStorage, setSelectTenant } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';
import moment from 'moment';
import config from '../../config';
import SelectTenant from '../../components/Select/SelectTenant';

class PatientsManager extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tenant: 0,
      dialogPatient: {
        open: false,
      },
      dialogActivities: {
        id: null,
        open: false,
      },
      data: {
        patient: null,
      },
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order, action, tenantIds } = this.props.patient.toJS();
    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });
      await this.props.patient.getPatient(offset, limit, search, sort, order, tenantIds);
      this.props.patient.setAction('action', null);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });

      this.props.patient.resetData();
      await this.props.patient.setPagination('tenantIds', tenantIds);
      // await this.props.patient.getPatient();
    }
  }

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h3>${t('delete_patient')}</h3>`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      const { t } = this.props;
      if (result.value) {
        try {
          const { patientList } = this.props.patient.toJS();
          const patient = patientList.data.find((item) => item.id === id);
          if (patient.devices.length > 0) {
            patient.devices.forEach(async (data) => {
              await this.props.device.unAssignDeviceToPatient(data.id, data.serial);
            });
          }
          await this.props.setting.settingDelete(patient.id);
          const bed = await this.props.bed.getBedPatient(patient.id);
          if (bed.id) {
            const data = { id: bed.id };
            await this.props.dashboard.discharge(data, false);
          }
          const result = await this.props.patient.deletePatient(id);
          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('delete_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.patient.toJS();
                await this.props.patient.getPatient(offset, limit, search, sort, order, tenantIds);
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
    });
  }

  handleClickOpenDialogActivities = async (id) => {
    const { t } = this.props;
    try {
      let queryOption = {};
      if (localStorage.getItem('role_id') === '1') {
        queryOption = {
          activity: true,
          movement: true,
          alert: true,
          location: true,
          battery: true,
          admin: true,
        };
      } else {
        queryOption = {
          activity: true,
          movement: true,
          location: true,
        };
      }

      const queryVitalsign = {
        heartrate: true,
        temperature: true,
        bloodPressure: true,
        spo2: true,
      };
      const patient = await this.props.patient.getPatientById(id);
      this.setState({
        dialogActivities: { open: true, id: id },
        data: { patient },
      });

      this.props.summary.resetSummary(true);
      await this.props.summary.getGraphAvailableDate(id);
      this.props.summary.getVitalSignDate(id);
      this.props.summary.getAssignedDeviceDate(id);
      config.features.report.garmin && this.props.summary.getGarminDate(id);
      this.props.summary.getDeviceUsage(id, new Date());
      this.props.summary.getSummary(id, new Date(), queryOption);
      this.props.summary.getSummaryReport(id, new Date());
      this.props.summary.getSummaryReportAsPeriod(id, new Date(), 'week', ['sleep', 'event']);
      this.props.vitalsign.getLastVitalSign(id, new Date(), queryVitalsign);
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({ html: `<h4>${t('can_not_open')}`, type: 'error' });
      }
    }
  };

  handleClose = () => {
    this.setState({ dialogActivities: { open: false, id: null } });
  };

  createPatient() {
    const { classes, t } = this.props;
    return (
      <Button
        id='create-patient'
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('patients/create')}
        className={classes.button}
      >
        <Icons.Add />
        {t('create_patient')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.patient.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.patient.setPagination('offset', 0, false);
    this.props.patient.setPagination('search', value);
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    await this.props.patient.setPagination('tenantIds', tenantIds);
    setSelectTenant(tenantIds);
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  getFullname = (language, data, arraySize) => {
    let fullname = '';
    const validateTableRow = Boolean(this.validateTableRow(data, arraySize));

    if (language && language === 'th-TH' && validateTableRow) {
      if (data[2] || data[3]) {
        fullname = `${data[2] ?? ''} ${data[3] ?? ''}`;
      } else {
        fullname = `${data[8] ?? ''} ${data[9] ?? ''}`;
      }
    }

    if (language && language === 'en-EN' && validateTableRow) {
      if (data[8] || data[9]) {
        fullname = `${data[8] ?? ''} ${data[9] ?? ''}`;
      } else {
        fullname = `${data[2] ?? ''} ${data[3] ?? ''}`;
      }
    }

    return fullname;
  };

  getCurrentAssignedDevice = (devices) => {
    return {
      assignedDevices: devices && devices.length > 0 ? devices.map((v) => v.name) : [],
      reportOptions: {
        hasActivity: devices && devices.length > 0 ? this.hasReport(devices, 'motionTracker') : true,
        hasLocalization: devices && devices.length > 0 ? this.hasReport(devices, 'localization') : true,
      },
    };
  };

  hasReport(devices, reportType) {
    const found = devices.filter((d) => {
      if (!d.deviceVersion) {
        return false;
      }
      const deviceProperty = d.deviceVersion['property'] ? JSON.parse(d.deviceVersion['property']) : null;
      if (deviceProperty) {
        return deviceProperty[reportType] === 1;
      }

      return false;
    });
    return found.length > 0;
  }

  handleChangeRowsPerPage = (value) => {
    this.props.patient.setPagination('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.patient.toJS();
    this.props.patient.setPagination('offset', value * limit);
  };

  render() {
    const { classes, t } = this.props;
    let { patientList, loading, search, sort, order, limit } = this.props.patient.toJS();
    const page = patientList.data ? patientList.pagination.page - 1 : 0;
    const count = patientList.data ? patientList.pagination.count : 0;

    (patientList.data || []).map((item) => {
      let fullname = '';
      if (localStorage.getItem('i18nextLng') === 'th-TH') {
        if (item.firstname && item.lastname) {
          fullname = `${item.firstname} ${item.lastname}`;
        } else {
          fullname = `${item.firstnameEn} ${item.lastnameEn}`;
        }
      }
      if (localStorage.getItem('i18nextLng') === 'en-EN') {
        if (item.firstnameEn && item.lastnameEn) {
          fullname = `${item.firstnameEn} ${item.lastnameEn}`;
        } else {
          fullname = `${item.firstname} ${item.lastname}`;
        }
      }

      item.fullname = fullname;

      if (item.dob) {
        const dateDob = new Date(item.dob);
        const formattedDob = `${dateDob.getFullYear()}-${('0' + (dateDob.getMonth() + 1)).slice(-2)}-${('0' + dateDob.getDate()).slice(-2)}`;
        item.age = moment(new Date()).diff(formattedDob, 'years');
      } else {
        item.age = '';
      }
      return item;
    });

    const ARRAYSIZE = 11;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'hn',
        label: `${t('hn_id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'hn' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[1]}</div>;
          },
        },
      },
      {
        name: 'fullname',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'fullname' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.columnWidth200}>
                <Typography className={classes.fontOfName}>{row[2]}</Typography>
              </div>
            );
          },
        },
      },
      {
        name: 'lastname',
        label: `${t('last_name')}`,
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'gender',
        label: `${t('gender')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'gender' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            let result;
            switch (this.validateTableRow(row, ARRAYSIZE) && row[4]) {
              case 'F':
                result = <div className={classes.columnWidth200}>{t('female')}</div>;
                break;
              case 'M':
                result = <div className={classes.columnWidth200}>{t('male')}</div>;
                break;
              default:
                break;
            }
            return result;
          },
        },
      },
      {
        name: 'age',
        label: `${t('age')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'age' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[5]}</div>;
          },
        },
      },
      {
        name: 'status',
        label: `${t('status')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'status' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.columnWidth200} id={row && row[1]}>
                {this.validateTableRow(row, ARRAYSIZE) && row[6]}
              </div>
            );
          },
        },
      },
      {
        name: 'tenant.name',
        label: `${t('tenant')}`,
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[7]}</div>;
          },
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                <Button
                  variant='outlined'
                  color='primary'
                  className={classes.button}
                  onClick={() =>
                    this.handleClickOpenDialogActivities(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')
                  }
                >
                  {t('activity_summary')}
                </Button>
                <Link
                  to={`/app/patients/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}
                  title={t('view')}
                >
                  {' '}
                  <IconButton>
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link
                  to={`/app/patients/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`}
                  title={t('edit')}
                >
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  title={t('delete')}
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.Delete color='primary' />
                </IconButton>
              </div>
            );
          },
        },
      },
      {
        name: 'firstnameEn',
        label: `${t('first_name_en')}`,
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'lastnameEn',
        label: `${t('last_name_en')}`,
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_patients')} button={this.createPatient()}>
          {this.titleContent()}
        </PageTitle>
        <Grid container spacing={32} className={classes.mainContain}>
          <Grid item xs={12}>
            <MUIDataTable
              data={patientList.data}
              columns={columns}
              options={{
                count: patientList.data ? patientList.pagination.count : 0,
                page: patientList.data ? patientList.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.patient.setPagination('offset', tableState.page * tableState.rowsPerPage);
                      break;
                    case 'changeRowsPerPage':
                      this.props.patient.setPagination('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.patient.setPagination('offset', 0, false);
                      this.props.patient.setPagination('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.patient.setPagination('offset', 0, false);
                      this.props.patient.setPagination('sort', sortList[4], false);
                      this.props.patient.setPagination('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
        {this.state.dialogActivities.open && (
          <SummaryReportPage
            open={this.state.dialogActivities.open}
            data={this.state.data}
            handleClose={this.handleClose}
            currentAssignedDevice={this.getCurrentAssignedDevice(
              this.state.data && this.state.data.patient && this.state.data.patient.devices,
            )}
          />
        )}
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
    marginTop: 11,
  },
  formInput: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    '& label': {
      transform: 'translate(0px, 7px) scale(0.7) !important',
      fontSize: '1.33rem !important',
    },
  },
  actionBox: {
    minWidth: '280px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
  fontOfName: {
    fontSize: 16,
  },
});

export const page = inject(
  'patient',
  'event',
  'logActivity',
  'device',
  'dashboard',
  'bed',
  'setting',
  'summary',
  'vitalsign',
)(observer(PatientsManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
